import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function JetpackSlideshow({ html }) {
  const slides = [...html.matchAll(/wp-block-jetpack-slideshow_image[^>]+src="([^"]+)"/g)].map((m) => m[1]);

  if (!slides.length) return null;

  return (
    <div className='blog-carousel'>
      <div className='carousel-wrapper'>
        <div className='carousel-arrow prev'></div>

        <Swiper
          modules={[Navigation, Pagination]}
          //   slidesPerView={}
          loop
          navigation={{
            prevEl: '.carousel-arrow.prev',
            nextEl: '.carousel-arrow.next'
          }}
          pagination={{
            el: '.carousel-pagination',
            clickable: true
          }}
        >
          {slides.map((src, i) => (
            <SwiperSlide key={i}>
              <img src={src} alt='' className='carousel-image' />
            </SwiperSlide>
          ))}
        </Swiper>

        <div className='carousel-arrow next'></div>
      </div>

      <div className='carousel-pagination'></div>
    </div>
  );
}
